import styled from "styled-components";

export const Root = styled.main`
   grid-area: content;
`;
